angular
  .module('sms.common.services')
  .service('studentIdentityValidationService', studentIdentityValidation)

const NUMERIC_REGEX = /^\d+$/

function studentIdentityValidation() {
  const service = {}
  service.penPattern = NUMERIC_REGEX
  service.pupilNumberPattern = NUMERIC_REGEX
  return service
}
